import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Persist token in localStorage for header-based auth (works cross-origin even
// when cookies get blocked). Server also sets an httpOnly cookie.
const TOKEN_KEY = "dinepulse.token";

export function getToken() {
    try {
        return localStorage.getItem(TOKEN_KEY);
    } catch {
        return null;
    }
}

export function setToken(t) {
    try {
        if (t) localStorage.setItem(TOKEN_KEY, t);
        else localStorage.removeItem(TOKEN_KEY);
    } catch {
        // ignore
    }
}

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const t = getToken();
    if (t) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

export function fileUrl(pathOrId) {
    if (!pathOrId) return null;
    if (typeof pathOrId === "string" && pathOrId.startsWith("http")) return pathOrId;
    if (typeof pathOrId === "string" && pathOrId.startsWith("/api/")) {
        return `${BACKEND_URL}${pathOrId}`;
    }
    return `${API_BASE}/files/${pathOrId}`;
}

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Something went wrong";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
